<template>

    <div id="report-render">

        <div v-if="loaded">

            <div class="w-full px-8 py-4 bg-gray-700 text-white text-sm flex mt-4 mb-0"  v-if="render_error">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-20 md:w-12 lg:w-6 text-brand-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" focusable="false" role="img" aria-label="report-results-warning">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
                <p class="ml-4" v-if="isAdmin">
                    {{ render_error.message }}
                </p>
                <p class="ml-4" v-else>
                    An error occurred while trying to render this report, please contact support.
                </p>
            </div>

            <div v-if="id && form.report_results">
                <ReportResults :is_admin="isAdmin" v-model="form" @showPendingReports="showPendingReports"></ReportResults>
            </div>
            <form class="py-6" method="post" @submit.prevent="renderReport(id)" v-else-if="id">

                <ul class="top-help-block">
                    <li><span class="text-brand-700">*</span> denotes required field</li>
                </ul>

                <div class="bg-white overflow-hidden shadow rounded-lg p-6">
                    <div class="panel-form">
                        <div class="panel-title">
                            <h2>{{ form.report_structure.name }}</h2>
                            <p>{{ form.report_structure.description }}</p>
                        </div>
                        <div class="panel-section">
                            <ReportParameters v-model="form" :show_date_fields="true"></ReportParameters>
                        </div>
                    </div>
                </div>
                <div class="flex mt-6 justify-end">

                    <button type="button" class="btn-outline" @click.prevent="showReport">Go Back</button>

                    <router-link :to="{ name: 'report.edit', params: { report: id } }" class="btn-error text-sm ml-3 hover:text-white" v-if="isAdmin && render_error">
                        Edit Report
                    </router-link>

                    <button type="submit" class="btn ml-3">Run Report</button>

                </div>
            </form>
            <div class="py-6" v-else>
                <div class="no-results panel">
                    <div class="p-10">
                        <div class="text-gray-200 my-6">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-20 w-20 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" />
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z" />
                            </svg>
                        </div>

                        <h2 class="text-gray-600 font-medium text-2xl text-center">No Reports Selected</h2>

                        <p class="text-center mt-4 text-sm text-gray-500">
                            No report selected, please <a href="#" @click.prevent="showReportIndex">select a report</a>.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <Loading message="Loading Report" v-else></Loading>


    </div>

</template>

<script>
import Loading from "../Support/Loading";
import { Datetime } from 'vue-datetime';
import {RenderReport} from "../../app/Report/RenderReport";
import ReportIndex from "./ReportIndex";
import ReportParameters from "./ReportParameters";
import ReportResults from "./ReportResults";
import {PermissionMixin} from "../../support/mixins";

export default {
    name: "ReportRender",
    mixins: [PermissionMixin],
    props: {
        id: {
            required: false,
            default: false
        }
    },
    components: {
        ReportIndex,
        ReportParameters,
        ReportResults,
        Loading,
        datetime: Datetime,
    },
    data() {
        return {
            section: 'index',
            form: false,
            loaded: false,
            render_error: false,
        }
    },
    computed: {
        isAdmin() {
            return this.$parent.isAdmin;
        }
    },
    methods: {
        showReportIndex() {
            this.$emit('showReportIndex');
        },
        showReport(payload) {
            this.$emit('showReport', payload);
        },
        renderReport(id) {
            let vm = this;
            vm.loaded = false;
            vm.render_error = false;


            vm.form.previewReport().then(r => {
                vm.loaded = true;
            }).catch(error => {
                vm.render_error = error.response.data;
                vm.loaded = true;

                vm.handleError(error);
            });
        },
        setFieldValue(event) {
            this.data.data[event.name] = event.value;
        },
        showPendingReports() {
            this.$emit('showPendingReports');
        }
    },
    mounted() {
        let vm = this;
        vm.report = this.$router.currentRoute.params.report;

        new Promise(resolve => {
            vm.form = new RenderReport;

            if (vm.id === null) {
                resolve(true);
            } else {
                vm.form.showReport(vm.id).then(response => {
                    vm.form.hasRenderFields();

                    resolve(true);
                }).catch(error => vm.handleError(error));
            }
        }).then(r => {
            vm.loaded = r;
        })
    }
}
</script>